import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const TokenInput = ({ onTokenSubmit }) => {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const { t } = useTranslation();

  const handleSubmit = e => {
    e.preventDefault();
    if (!token.trim()) {
      setError('Please enter a token');
      return;
    }
    setError('');
    onTokenSubmit(token);
  };

  return (
    <div className="token-input-container">
      <h2>{t('enterToken')}</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={token}
          onChange={e => setToken(e.target.value)}
          placeholder="Token"
          className="token-input"
        />
        {error && <p className="error">{error}</p>}
        <button type="submit" className="submit-button">
          {t('submit')}
        </button>
      </form>
    </div>
  );
};

export default TokenInput;
